























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Schedule    from '../model/Schedule';
import Session     from '../model/Session';
import Participant from '../model/Participant';
import Options     from '../model/Options';

import OptimizationResult from '../helpers/Annealer';

@Component
export default class ScheduleGrid extends Vue {
  @Prop() private schedule!: Schedule;
  @Prop() private options!: Options;
  @Prop() private optimizerResult: OptimizationResult | undefined;

  private focus: Participant | null = null;

  private newBestScore = false;

  public toggleFocus(participant: Participant) {
    this.focus =
      (this.focus === participant)
        ? null
        : participant;
  }

  public isSessionFocused(sessionID: number): boolean {
    return this.focus && this.focus.votes.includes(sessionID) || false;
  }

  public formatFixed(value: number | null | undefined, precision: number) {
    if (value) {
      return value.toFixed(precision);
    }
  }

  @Watch('optimizerResult')
  public onNewBestScore(newValue: any, oldValue: any) {
    if (oldValue && newValue) {
      this.newBestScore = false;
      setTimeout(() => this.newBestScore = true, 0.01);
    }
  }
}
